var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#5C412A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10566 20.1742L7.99268 23.1421C7.94994 23.2563 7.94098 23.3804 7.96687 23.4996C7.99277 23.6188 8.05241 23.728 8.13869 23.8142C8.22497 23.9004 8.33423 23.9599 8.45343 23.9857C8.57263 24.0114 8.69672 24.0023 8.8109 23.9595L11.778 22.8465C12.1176 22.7193 12.426 22.5209 12.6826 22.2646L21.2773 13.6699C21.2773 13.6699 20.9774 12.7712 20.0796 11.8726C19.1818 10.9747 18.2822 10.6749 18.2822 10.6749L9.68756 19.2696C9.43126 19.5261 9.23285 19.8346 9.10566 20.1742ZM19.4808 9.47635L20.6522 8.30493C20.8622 8.09487 21.1426 7.96104 21.4357 8.01017C21.8482 8.07793 22.4792 8.28291 23.0738 8.87836C23.6693 9.47381 23.8742 10.104 23.942 10.5165C23.9911 10.8096 23.8573 11.0899 23.6472 11.3L22.475 12.4714C22.475 12.4714 22.176 11.5736 21.2773 10.6757C20.3794 9.7762 19.4808 9.47635 19.4808 9.47635Z",
    fill: "#FFDCA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSvg);
export default __webpack_public_path__ + "static/media/EditSVG.0a121425df22717fe6d0c6a39ae49254.svg";
export { ForwardRef as ReactComponent };